<div class="modal-header">
    <h5 class="modal-title" id="editLetterTitle">Edit Letter</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12 mb-3">
            <label for="letterContent" class="form-label">Letter Content</label>
            <!--<textarea class="form-control" id="letterContent" rows="10"></textarea>-->
            <editor [(ngModel)]="letter.letterContent" class="form-control" initialValue="newsInfo.articleContent" licenseKey="gpl" [init]="{
                base_url: '/tinymce',
                suffix: '.min',
                menubar: false,
                statusbar: false,
                toolbar: false,
                height: 800,
                skin: '../../../assets/css/tinymce',
                content_style: 'body { color: #FFFFFF; }',
            }"></editor>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sb border-lb text-strong text-uppercase m-100" (click)="UpdateLetter()">Save</button>
    <button type="button" class="btn btn-cancel text-strong text-uppercase m-100" (click)="dismiss()">Cancel</button>
</div>